/** Persist in-flight analysis across page navigation. */

export const INFLIGHT_ANALYSIS_KEY = 'inflight_analysis';

export type InflightAnalysisRecord = {
  analysisSessionId: string;
  scriptTitle: string;
  workflowSessionId: string;
};

export function getInflightAnalysis(): InflightAnalysisRecord | null {
  try {
    const raw = sessionStorage.getItem(INFLIGHT_ANALYSIS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as InflightAnalysisRecord;
    if (!parsed.analysisSessionId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setInflightAnalysis(record: Partial<InflightAnalysisRecord> & { analysisSessionId?: string }) {
  const prev = getInflightAnalysis();
  const next: InflightAnalysisRecord = {
    analysisSessionId: record.analysisSessionId ?? prev?.analysisSessionId ?? '',
    scriptTitle: record.scriptTitle ?? prev?.scriptTitle ?? 'Script',
    workflowSessionId: record.workflowSessionId ?? prev?.workflowSessionId ?? '',
  };
  if (!next.analysisSessionId) return;
  sessionStorage.setItem(INFLIGHT_ANALYSIS_KEY, JSON.stringify(next));
}

export function clearInflightAnalysis() {
  sessionStorage.removeItem(INFLIGHT_ANALYSIS_KEY);
}
